import { render, staticRenderFns } from "./selectRole.vue?vue&type=template&id=a5aa3f6c&scoped=true&"
import script from "./selectRole.vue?vue&type=script&lang=js&"
export * from "./selectRole.vue?vue&type=script&lang=js&"
import style0 from "./selectRole.vue?vue&type=style&index=0&id=a5aa3f6c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5aa3f6c",
  null
  
)

export default component.exports